"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImagePreviewItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _Gallery = require("b2b-components/theme/components/Gallery");
var _image = require("b2b-components/theme/components/Gallery/utils/image");
var _FallbackItem = require("../FallbackItem");
var _Item = require("../Item");
var _ItemImage = require("../ItemImage");
const ImagePreviewItem = _ref => {
  let {
    image,
    imageUrl,
    title,
    className,
    isPreview,
    isCurrent,
    onClick,
    totalItemCount,
    imageDisclaimer
  } = _ref;
  if (!image[_image.IMAGE_SIZE.preview]) {
    return /*#__PURE__*/_react.default.createElement(_FallbackItem.FallbackItem, {
      title: title
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Item.Item, {
    className: className,
    isPreview: isPreview,
    isCurrent: isCurrent,
    onClick: onClick,
    totalItemCount: totalItemCount,
    href: (0, _image.getImageSrc)(image, imageUrl, _image.IMAGE_SIZE.full),
    type: _Gallery.GALLERY_ITEM_TYPE.image,
    imageDisclaimer: imageDisclaimer
  }, /*#__PURE__*/_react.default.createElement(_ItemImage.ItemImage, {
    src: (0, _image.getImageSrc)(image, imageUrl, _image.IMAGE_SIZE.preview),
    title: title
  }));
};
exports.ImagePreviewItem = ImagePreviewItem;
//# sourceMappingURL=ImagePreviewItem.js.map